/**
 * Původní text autora recenze z exportu Takeout (F2.2). Google do `comment` vkládá svůj
 * strojový překlad ve dvou tvarech (`takeout-format.md`):
 *   „původní\n\n(Translated by Google)\npřeklad“ a
 *   „(Translated by Google) překlad\n\n(Original)\npůvodní“.
 * Zobrazuje se vždy jen původní text, nikdy překlad.
 */
export const TRANSLATION_MARKERS = ["(Translated by Google)", "(Original)"] as const;

const [TRANSLATED, ORIGINAL] = TRANSLATION_MARKERS;

/**
 * Text bez značky vrací BEZE ZMĚNY (ani `trim`, ořez dělá volající); text, ve kterém je
 * jen překlad, vrací `""`, aby se překlad nikdy nevydal za text autora.
 */
export function originalReviewText(comment: string): string {
  if (comment.trimStart().startsWith(TRANSLATED)) {
    const at = comment.indexOf(ORIGINAL);
    return at < 0 ? "" : comment.slice(at + ORIGINAL.length).trim();
  }
  const at = comment.indexOf(TRANSLATED);
  return at < 0 ? comment : comment.slice(0, at).trim();
}
